import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=681ab0a4&scoped=true&"
import script from "./ItemDetails.vue?vue&type=script&lang=js&"
export * from "./ItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ItemDetails.vue?vue&type=style&index=0&id=681ab0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ab0a4",
  null
  
)

export default component.exports